import React from "react";
import { Box } from "@mui/material";

function InternationalTransfersLogo({ logo, handleClick, name }) {

    return (
    <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
    >
        <Box component={"img"}
            src={logo}
            sx={{
                height: 75,
                width: "auto",
                objectFit: "contain",
              }}
        >
        </Box>
        <Box
            className="mt-3 fw-500"
        >
            {name.toUpperCase()}
        </Box>
    </Box>
    );
}

export default InternationalTransfersLogo;